

































import { Component, Mixins } from 'vue-property-decorator'
import { toNumber } from 'lodash'
import { productLinkUrl } from '@core/utils/jump'
import RecommendItem from './mixins/RecommendItem'

@Component
export default class CmmdtyItem extends Mixins(RecommendItem) {
  get promotion1() {
    return (this.value.promotion1 && this.value.promotion1[0]) || ''
  }

  get promotion2() {
    if (this.promotion1) {
      return ''
    } else {
      return (this.value.promotion2 && this.value.promotion2[0]) || ''
    }
  }

  get isSelf() {
    return this.value.businessId == 41215
  }

  get isSelf2() {
    return this.value.selfPurchase === 1
  }

  get goDetailExposure() {
    const { spuId, spuName } = this.value
    return `200018||${JSON.stringify({ spuid: spuId, name: spuName, tabname: this.tab.tabName })}`
  }
  goDetail() {
    const { spuId, spuName } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200018', positionParam: { spuid: spuId, name: spuName, tabname: this.tab.tabName } })
  }
  get imgUrl() {
    let url = this.value.cmmdtyImage
    if (this.value.cmmdtyVideoUrl && this.value.cmmdtyVideoUrl.length > 0) {
      url = this.value.cmmdtyVideoPicture
    } else if (this.value.recommendImage && this.value.recommendImage.length > 0) {
      url = this.value.recommendImage
    }
    return url
  }

  get imgHeight() {
    let photoH = 256
    const kItemWidth = 342
    if ((this.value.cmmdtyVideoUrl && this.value.cmmdtyVideoUrl.length > 0) || (this.value.recommendImage && this.value.recommendImage.length > 0)) {
      ///优先显示顺序:商品视频 > 商品种草图 > 商品首图
      const h = toNumber(this.value.cmmdtyVideoUrl ? this.value.cmmdtyVideoHeight : this.value.recommendHeight) || 0
      const w = toNumber(this.value.cmmdtyVideoUrl ? this.value.cmmdtyVideoWidth : this.value.recommendWidth) || 0
      if (h > 0 && w > 0) {
        photoH = ((h * 1.0) / w) * kItemWidth
        //竖版图最大宽高比9：16，横版图最小宽高比4：3
        const rate = (w * 1.0) / h
        const rateDefV = 9.0 / 16
        const rateDefH = 4.0 / 3
        if (h >= w) {
          //竖版
          if (rate < rateDefV) {
            photoH = (kItemWidth * 1.0) / rateDefV
          }
        } else {
          //横版
          if (rate > rateDefH) {
            photoH = (kItemWidth * 1.0) / rateDefH
          }
        }
      }
    }
    return photoH
  }
  get linkUrl() {
    return productLinkUrl(this.value.linkUrl, 5)
  }
}
